import GoalsSerializer from './base';

export default class Subject extends GoalsSerializer {
  normalize(model, hash, prop) {
    let defaults = {
      subjectType: 0,
    };
    Object.assign(defaults, hash);
    hash = defaults;
    return super.normalize(model, hash, prop);
  }
}
